import React from 'react';
import { Skeleton } from '@execonline-inc/execonline-ui';

const AnnouncementsSkeleton: React.FC = () => (
  <div className="w-full space-y-4">
    {/* Create 3 announcement card skeletons */}
    {[...Array(3)].map((_, index) => (
      <div key={index} className="flex w-full gap-4 rounded-lg bg-white p-6 shadow">
        {/* Megaphone icon area */}
        <div className="flex-shrink-0">
          <Skeleton variant="circle" size="lg" style={{ width: '48px', height: '48px' }} />
        </div>

        {/* Content area - make it take full width */}
        <div className="min-w-0 flex-1">
          {/* Title - wider */}
          <Skeleton variant="text" size="lg" className="mb-2" style={{ width: '90%' }} />

          {/* Date and program name */}
          <div className="mb-3 flex items-center gap-2">
            <Skeleton variant="text" size="sm" style={{ width: '120px' }} />
            <span className="text-gray-400">•</span>
            <Skeleton variant="text" size="sm" style={{ width: '240px' }} />
          </div>

          {/* Content preview - full width */}
          <div className="space-y-1.5">
            <Skeleton variant="text" size="md" style={{ width: '100%' }} />
            <Skeleton variant="text" size="md" style={{ width: '95%' }} />
            <Skeleton variant="text" size="md" style={{ width: '85%' }} />
          </div>
        </div>
      </div>
    ))}
  </div>
);

export default AnnouncementsSkeleton;
